import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

const standalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone;
let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("ks-installable")); });

export const usePartnerManifest = () => {
  useEffect(() => {
    const link = document.querySelector("link[rel=manifest]");
    if (!link) return;
    const prev = link.getAttribute("href");
    link.setAttribute("href", "/partner-manifest.json");
    const theme = document.querySelector("meta[name=theme-color]");
    document.title = "Kindsaver Partner";
    return () => { link.setAttribute("href", prev); if (theme) theme.setAttribute("content", "#0D3B2B"); };
  }, []);
};

export const PartnerInstall = () => {
  const [can, setCan] = useState(!!deferred);
  useEffect(() => { const h = () => setCan(true); window.addEventListener("ks-installable", h); return () => window.removeEventListener("ks-installable", h); }, []);
  if (standalone()) return null;
  const go = async () => {
    if (deferred) { deferred.prompt(); await deferred.userChoice; deferred = null; setCan(false); return; }
    toast.info(/iphone|ipad/i.test(navigator.userAgent) ? "Tap Share, then \"Add to Home Screen\"." : "Open the browser menu (⋮) and tap \"Install app\" or \"Add to Home screen\".");
  };
  return (
    <button onClick={go} data-testid="partner-install-btn" className={`flex h-8 items-center gap-1 rounded-full px-3 text-xs font-bold ${can ? "bg-[#0D3B2B] text-white" : "border border-[#D2E0D8] text-[#0D3B2B]"}`}>
      <Download className="h-3.5 w-3.5" />Install app
    </button>
  );
};
